import { render, staticRenderFns } from "./PanelCompetitionFormBox.vue?vue&type=template&id=1ce9ca2c&scoped=true&"
import script from "./PanelCompetitionFormBox.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionFormBox.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionFormBox.vue?vue&type=style&index=0&id=1ce9ca2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce9ca2c",
  null
  
)

export default component.exports